import { render, staticRenderFns } from "./classes-students.vue?vue&type=template&id=1d3ed77d&scoped=true&"
import script from "./classes-students.vue?vue&type=script&lang=js&"
export * from "./classes-students.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ed77d",
  null
  
)

export default component.exports